// src/components/SmartFlow/nodes/HTTP_Request/HttpRequestNode.jsx

import React from 'react';
import BaseNode from '../../base/BaseNode';

/**
 * HTTP Request Node Component
 *
 * Displays HTTP request node in the workflow builder.
 * Uses BaseNode for consistent styling.
 */
const HttpRequestNode = ({ data, selected }) => {
  const config = data.config || {};


  const method = config.method || 'GET';
  const url = config.url || '';

  let subtitle = 'Not configured';
  if (url) {
    const displayUrl = url.length > 35 ? `${url.substring(0, 35)}...` : url;
    subtitle = `${method} ${displayUrl}`;
  }

  return (
    <BaseNode
      data={data}
      icon="bi-globe"
      color="#ff6d5a"
      label="HTTP Request"
      subtitle={subtitle}
      hasHandles={{ top: true, bottom: true }}
      selected={selected}
    />
  );
};

export default HttpRequestNode;
